import { Filter, Form, Mask } from '@/components'
import useQuery from '@/hooks/useQuery'
import React from 'react'

// import { Container } from './styles';

function FilterManualCastrations() {
  const query = useQuery()
  const q = query?.q ?? {}

  return (
    <Filter
      initialValues={{
        fullName_cont: q.fullName_cont ?? '',
        documentNumber_eq: q.documentNumber_eq ?? '',
        email_eq: q.email_eq ?? '',
        animalName_cont: q.animalName_cont ?? '',
        microchip_eq: q.microchip_eq ?? '',
      }}
      title="Filtrar animais"
      renderForm={({ setFieldValue }) => (
        <>
          <div className="divider text-center" data-content="Tutor" />
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="fullName_cont">Nome do tutor</Form.Label>
            <Form.ValidationField
              name="fullName_cont"
              className="input-sm"
              id="fullName_cont"
              autoComplete="none"
              placeholder="Fulano da Silva"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="documentNumber_eq">Documento do tutor</Form.Label>
            <Form.ValidationField name="documentNumber_eq">
              {
                ({ field }) => (
                  <Mask.CpfCnpj
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    className="input-sm"
                    placeholder="CPF/CNPJ do tutor"
                    id="documentNumber_eq"
                    onAccept={(value) => {
                      setFieldValue('documentNumber_eq', value)
                    }}
                  />
                )
              }
            </Form.ValidationField>
          </Form.Group>
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="email_eq">E-mail</Form.Label>
            <Form.ValidationField
              type="email"
              name="email_eq"
              className="input-sm"
              id="email_eq"
              autoComplete="none"
              placeholder="fulano@email.com"
            />
          </Form.Group>
          <div className="divider text-center" data-content="Pet" />
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="animalName_cont">Nome do pet</Form.Label>
            <Form.ValidationField
              name="animalName_cont"
              className="input-sm"
              id="animalName_cont"
              autoComplete="none"
              placeholder="Pet da Silva"
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="microchip_eq">Microchip</Form.Label>
            <Form.ValidationField
              name="microchip_eq"
              className="input-sm"
              id="microchip_eq"
              autoComplete="none"
              placeholder="Microchip"
            />
          </Form.Group>
        </>
      )}
    />
  )
}

export default FilterManualCastrations
